import { ENV } from "../utils";

export class Requirement {
  baseApi = ENV.BASE_API;

  async getRequirements(accessToken, active = true) {
    const url = `${this.baseApi}/requirements?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createRequirement(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-requirement`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateRequirement(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-requirement/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteRequirement(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-requirement/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
